import createTopic from '#/utils/createTopic';

export const userUnauthorizedTopic = createTopic<Record<string, unknown>>(
  'paradex-user-unauthorized',
);
